import { Toaster } from "@/components/ui/sonner"

import Icon from "./Icon"

const AppToaster = () => (
  <Toaster
    toastOptions={{
      classNames: {
        success:
          "!flex !h-auto !flex-row !items-center !rounded-xl !p-4 !gap-5 !text-sm !text-palette-jungleGreen900 !bg-palette-skyBlue200 !font-normal [&_[data-description]]:!text-palette-jungleGreen900",
        error:
          "!flex !h-auto !flex-row !items-center !rounded-xl !p-4 !gap-5 !text-sm !border !border-indicators-red !bg-white !text-indicators-red !font-normal [&_[data-description]]:!text-indicators-red",
        info: "!flex !h-auto !flex-row !items-center !rounded-xl !p-4 !gap-5 !text-sm !text-palette-jungleGreen900 !bg-white !font-normal",
      },
    }}
    icons={{
      success: (
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-palette-jungleGreen900">
          <Icon name="checkCircle" className="text-palette-skyBlue200" height={18} width={18} />
        </div>
      ),
      error: (
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-indicators-red">
          <Icon name="xCircle" className="text-white" height={24} width={24} />
        </div>
      ),
      info: (
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-palette-jungleGreen900">
          <Icon name="infoCircle" className="text-white" height={18} width={18} />
        </div>
      ),
    }}
  />
)

export default AppToaster
